import { connect } from "react-redux";
import { RootState } from "app/rootReducer";
import { AuthDialog, AuthLevel, showDialog, signOut as onSignOut, signUp as onSignUp, onResendConfirmationCode, onConfirmUser } from "features/auth/reducer";
import { fetchUserProfile as onFetchUserProfile } from "features/user/reducer";
import { navigateTo, View } from "features/global/reducer";
import OwnerSignupView from "./OwnerSignupView";

const mapStateToProps = (state: RootState) => ({
    isAuthenticated: state.auth.level === AuthLevel.User,
    urlData: state.global.urlData,
    userProfile: state.user.profile,
    token: state.global.urlData.token,
});

const mapDispatchToProps = {
    onFetchUserProfile,
    onNavigateToCalendar: () => navigateTo(View.Calendar),
    onShowLoginDialog: () => showDialog(AuthDialog.Login),
    onSignOut,
    onSignUp,
    onResendConfirmationCode,
    onConfirmUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerSignupView);
